import React, { useState, useEffect } from "react";
import { Cache } from "aws-amplify";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga4";

// aws configuration
import { Auth, Hub } from "../../../config/aws-exports";

// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { updateUserInfo, userClicked } from "../../../redux/actions";

// react icons
import { FcGoogle } from "react-icons/fc";
import { FaLinkedin } from "react-icons/fa";
// import { BsFacebook } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
// import facebookicon from "../../../assets/img/facebookicon.png"
import { GrApple } from "react-icons/gr";

import "./SocialOptions.css";
import { APP_NAME, EVENTS, PAGE, PAGE_TYPE } from "../../../../../../packages/skillgigs-employer-web-app/src/constants/userTrackingConstants";

const SocialOptions = (props) => {

  const uuid = useSelector((state) => state.userTrackingReducer.uuid);

  const dispatch = useDispatch();

  const storeAsEmployer = () => {
    try {
      if (window.location.pathname.split("/").includes("employer")) {
        localStorage.setItem("asEmployer", true);
        localStorage.removeItem("asTalent");
      } else {
        localStorage.removeItem("asEmployer");
      }
    } catch {}
  };

  return (
    <div>
      <section className="socialButtonsTop">
        <div
          className="socialButton facebookColor"
          onClick={() => {
            ReactGA.event({
              category: "User Interaction",
              action:
                APP_NAME.EMPLOYER +
                " " +
                (props.signUpLogin
                  ? EVENTS.FACEBOOK_SIGNUP_CLICK
                  : EVENTS.FACEBOOK_SIGNIN_CLICK),
              label: "Signup Button",
            });

            dispatch(
              userClicked({
                uuid: uuid,
                event: props.signUpLogin
                  ? EVENTS.FACEBOOK_SIGNUP_CLICK
                  : EVENTS.FACEBOOK_SIGNIN_CLICK,
                pageType: props.signUpLogin ? PAGE_TYPE.SIGNUP : PAGE_TYPE.SIGNIN,
                page: PAGE.MODAL,
                appName: APP_NAME.EMPLOYER,
                url: window?.location?.pathname,
              })
            );
            storeAsEmployer();
            Auth.federatedSignIn({ provider: "Facebook" });
          }}
        >
          <FaFacebook
            size={16}
            style={{
              position: "relative",
              // top: "4px",
              // marginLeft: "1.875rem",
              // marginRight: '0.5rem'
            }}
          />
          <span className="buttonFont">
            {props.signUpLogin ? "Join" : "Sign in"} with facebook
          </span>
          <div></div>
        </div>

        <div
          className="socialButton googleColor"
          onClick={() => {
            ReactGA.event({
              category: "User Interaction",
              action:
                APP_NAME.EMPLOYER +
                " " +
                (props.signUpLogin
                  ? EVENTS.GOOGLE_SIGNUP_CLICK
                  : EVENTS.GOOGLE_SIGNIN_CLICK),
              label: "Signup Button",
            });

            dispatch(
              userClicked({
                uuid: uuid,
                event: props.signUpLogin
                  ? EVENTS.GOOGLE_SIGNUP_CLICK
                  : EVENTS.GOOGLE_SIGNIN_CLICK,
                pageType: props.signUpLogin ? PAGE_TYPE.SIGNUP : PAGE_TYPE.SIGNIN,
                page: PAGE.MODAL,
                appName: APP_NAME.EMPLOYER,
                url: window?.location?.pathname,
              })
            );
            storeAsEmployer();
            Auth.federatedSignIn({ provider: "Google" });
          }}
        >
          <FcGoogle
            size={16}
            style={{
              position: "relative",
              // top: "4px",
              // marginLeft: "1.875rem",
              // marginRight: '0.5rem'
            }}
          />
          <span className="whiteBgButtonFont">
            {props.signUpLogin ? "Join" : "Sign in"} with google
          </span>
          <div></div>
        </div>
        <div
          className="socialButton appleColor"
          // onClick={() => {
          //   Auth.federatedSignIn({ provider: "Google" });
          // }}
          onClick={() => {
            ReactGA.event({
              category: "User Interaction",
              action:
                APP_NAME.EMPLOYER +
                " " +
                (props.signUpLogin
                  ? EVENTS.APPLE_SIGNUP_CLICK
                  : EVENTS.APPLE_SIGNIN_CLICK),
              label: "Signup Button",
            });

            dispatch(
              userClicked({
                uuid: uuid,
                event: props.signUpLogin
                  ? EVENTS.APPLE_SIGNUP_CLICK
                  : EVENTS.APPLE_SIGNIN_CLICK,
                pageType: props.signUpLogin ? PAGE_TYPE.SIGNUP : PAGE_TYPE.SIGNIN,
                page: PAGE.MODAL,
                appName: APP_NAME.EMPLOYER,
                url: window?.location?.pathname,
              })
            );
            storeAsEmployer();
            Auth.federatedSignIn({ provider: "SignInWithApple" });
          }}
        >
          <GrApple
            size={16}
            style={{
              position: "relative",
              // top: "3px",
              color: "black",
              // marginLeft: "1.875rem",
              // marginRight: '0.5rem'
            }}
          />
          <span className="whiteBgButtonFont">
            {/* style={{ marginLeft: "2.3rem" }} */}
            {props.signUpLogin ? "Join" : "Sign in"} with apple
          </span>
          <div></div>
        </div>
        <a
          onClick={() => {
            ReactGA.event({
              category: "User Interaction",
              action:
                APP_NAME.EMPLOYER +
                " " +
                (props.signUpLogin
                  ? EVENTS.LINKEDIN_SIGNUP_CLICK
                  : EVENTS.LINKEDIN_SIGNIN_CLICK),
              label: "Signup Button",
            });

            dispatch(
              userClicked({
                uuid: uuid,
                event: props.signUpLogin
                  ? EVENTS.LINKEDIN_SIGNUP_CLICK
                  : EVENTS.LINKEDIN_SIGNIN_CLICK,
                pageType: props.signUpLogin ? PAGE_TYPE.SIGNUP : PAGE_TYPE.SIGNIN,
                page: PAGE.MODAL,
                appName: APP_NAME.EMPLOYER,
                url: window?.location?.pathname,
              })
            );            
            storeAsEmployer();
          }}
          href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LinkedInClientID}&redirect_uri=${process.env.REACT_APP_MY_URL}/linkcheck&state=foobar&scope=r_liteprofile%20r_emailaddress`}
        >
          <div className="socialButton linkedINColor">
            <FaLinkedin
              size={16}
              style={{
                position: "relative",
                // top: "4px",
                // marginLeft: "1.875rem",
                // marginRight: "0.5rem",
              }}
            />
            <span className="buttonFont">
              {/* style={{ marginLeft: "1.725rem" }} */}
              {props.signUpLogin ? "Join" : "Sign in"} with linkedin
            </span>
            <div></div>
          </div>
        </a>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.user,
    error: state.authReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendAuthToken: (params) => {
      dispatch(updateUserInfo(params)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SocialOptions);
